import { ActivationActions } from './activation';
import { BUSINESS_MODEL_MARKETPLACE, HANDLING_FEE_ORDER, PAYMENT_CYCLE_MONTHLY } from '../../constants/operators';
import { CURRENT_RETAILER } from '../constants/retailerTypes';

export const OperatorsActions = {
  businessModel: '[operators] businessModel',
  configuration: '[operators] configuration',
  contacts: '[operator] contacts',
  warehouses: '[operators] warehouses',
  loading: '[operators] loading',
  loaded: '[operators] loaded',
};

const initialState = {
  businessModel: BUSINESS_MODEL_MARKETPLACE,
  configuration: {
    autoSync: null,
    commission: null,
    handlingFee: null,
    carrier: null,
    sla: null,
    invoice: null,
    paymentCycle: null,
    refundFee: null,
  },
  contacts: [],
  warehouses: [],
  loaded: false,
  loading: {
    data: false,
    contacts: false,
    warehouses: false,
    submit: false,
  },
};

const operators = (state = initialState, action) => {
  switch (action.type) {
    case ActivationActions.supplierRetailer:
    case CURRENT_RETAILER:
      return {
        ...state,
        businessModel: action.payload.order_type || BUSINESS_MODEL_MARKETPLACE,
        configuration: {
          autoSync: action.payload.auto_sync,
          handlingFee: {
            enabled: !!action.payload.handling_fee_formula,
            type: action.payload.handling_fee_formula?.type || HANDLING_FEE_ORDER,
            formula: (action.payload.handling_fee_formula?.formula || 0) / 100 || null,
          },
          commission: action.payload.operator_commission || 0,
          refundFee: (action.payload.refund_cost_formula || 0) / 100 || null,
          carrier: action.payload.replenishment_shipper_account_type
            ? {
                carrier: action.payload.replenishment_shipper_account_type,
                account: action.payload.replenishment_shipper_account,
              }
            : null,
          sla: action.payload.settings?.ecommerce_days_until_overdue_email || 1,
          invoice: {
            enabled: action.payload.ecommerce_send_invoice,
            value: action.payload.ecommerce_invoice_net_plus,
          },
          paymentCycle: action.payload.payment_cycle || PAYMENT_CYCLE_MONTHLY,
        },
        loading: {
          ...state.loading,
          data: false,
        },
        loaded: true,
      };

    case OperatorsActions.loaded:
      return {
        ...state,
        loaded: action.payload,
      };

    case OperatorsActions.loading:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload,
        },
      };

    case OperatorsActions.configuration:
      return {
        ...state,
        configuration: {
          ...state.configuration,
          ...action.payload,
        },
      };

    case OperatorsActions.contacts:
      return {
        ...state,
        contacts: action.payload,
      };

    case OperatorsActions.warehouses:
      return {
        ...state,
        warehouses: action.payload,
      };

    case OperatorsActions.businessModel:
      return {
        ...state,
        businessModel: action.payload,
      };

    case OperatorsActions.autoSync:
      return {
        ...state,
        autoSync: action.payload,
      };

    default:
      break;
  }

  return state;
};

export default operators;
